var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "trash-icon_svg__trash-icon__outline",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#868DA1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "trash-icon_svg__trash-icon__outline",
    d: "M1 4.4h15m-1.667 0v11.9c0 .939-.746 1.7-1.666 1.7H4.333c-.92 0-1.666-.761-1.666-1.7V4.4m2.5 0V2.7c0-.939.746-1.7 1.666-1.7h3.334c.92 0 1.666.761 1.666 1.7v1.7m-5 4.25v5.1m3.334-5.1v5.1"
  }))));
}

export default __webpack_public_path__ + "./fonts/trash-icon.9a1e7cc3ab2b33339b4d50074df623fc.svg";
export { SvgTrashIcon as ReactComponent };